<style lang="scss">
  @import "@/assets/scss/vuexy/components/login.scss";
</style>
<template>
  <div class="flex w-full" id="page-login">
    <div class="h-screen xs:w-full vx-col sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
      <vs-alert v-if="this.expired" :active="inputValid" color="danger" icon-pack="feather" icon="icon-info">
        <span>{{$t('Messages.Sesion')}}</span>
      </vs-alert>
      <div class="vx-row h-screen flex items-center">
        <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 ml-auto login-spore-bottom login-spore-container">
          <div class="float-left">
            <i18n class="forgotten-password-button" :isShow="true"/>
          </div>
          <div>
            <div class="image-center">
              <img src="@/assets/images/logo/Spore_Firma_RGB.png" alt="login" class="login-image-container">
            </div>
            <div class="vx-card__title mb-4 grid justify-items-center login-spore-title">
              <h2 class="mb-4 forgotten-password-button">{{$t("WelcomeMessage")}}</h2 >
              <p class="forgotten-password-button">{{$t("InputDataMessage")}}</p>
            </div>

            <div>
              <vs-input
                name="email"
                icon-no-border
                icon="icon icon-user"
                icon-pack="feather"
                :placeholder="$t('Email')"
                v-model="email"
                class="w-full spore-input-login" v-on:keyup.13="getLogin"/>

              <vs-input
                type="password"
                name="password"
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                :placeholder="$t('Password')"
                v-model="password"
                class="w-full mt-6 spore-input-login" v-on:keyup.13="getLogin"/>
              <span class="text-danger text-sm" v-show="error">{{$t("Messages.MissingParams")}}</span>
              <div class="flex flex-wrap justify-between my-5" >
                <div class="float-right">
                  <router-link class="forgotten-password-button" to="/forgot-password">{{$t("ForgotPassword")}}</router-link>
                </div>
              </div>
              <vs-button color="#fff" type="filled" text-color="#7577c8" class="w-full" style="margin-bottom: 50px; font-weight: 700 !important;"  v-on:click="getLogin()">{{$t("Enter")}}</vs-button>
            </div>
            <img src="@/assets/images/pages/login/background_responsive.png" class="login-image-spore-responsive">
          </div>
        </div>
      </div>
    </div>
    <div class="h-screen vx-col sm:w-full md:w-full lg:w-1/2 xl:w-1/2 container-login-image-spore">
       <img src="@/assets/images/pages/login/spore_lines_1.png" class="float-right spore-login-logo2 login-image-spore">
    </div>
  </div>
</template>
<script>
import { request } from '@/request.js'
import i18n from '@/layouts/components/vertical-nav-menu/I18n.vue'
import { parseJwt, setToken, setSessionStorage } from '@/sessionStorage.js'
import { app } from './../../main'

export default {
  components: {
    i18n
  },
  props: {
    urlLogin: String,
    redirectPath: String,
    img: String
  },
  data () {
    return {
      email: '',
      password: '',
      error: false,
      expired: false
    }
  },
  methods: {
    async getLogin () {
      if (this.email && this.password) {
        this.$vs.loading()
        this.error = false

        const params = {
          url: this.urlLogin,
          method: 'POST',
          validate: false,
          params: {
            email: this.email,
            password: btoa(this.password)
          }
        }
        await request(params).then(response => {
          setSessionStorage('email', btoa(this.email))
          setSessionStorage('pass', btoa(this.password))
          setToken(response.data.data)
          const j = parseJwt(response.data.data)
          setSessionStorage('userRole', j.u.type || 'MO')
          this.$store.commit('UPDATE_USER_INFO', {
            displayName: j.u.name || 'General User',
            uid: j.u.user_uuid || 0,
            avatar: undefined,
            userRole: j.u.type || 'MO',
            token: response.data.data
          })
          this.$router.push(this.redirectPath)
        }).finally(() => {
          this.$vs.loading.close()

          this.password = ''
        })
      } else this.error = true
    },
    getImg () {
      const images = require.context('@/assets/images/pages/login/', false, /\.png$/)
      if (app.$route.path === '/login') {
        this.expired = true
      }
      return images(`./${this.img}`)
    }
  }

}
</script>
